var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessengerAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3054 10.5354L11.1296 18.9079C9.55846 20.5168 6.92558 20.521 5.2461 18.9171C3.56662 17.3132 3.4789 14.7109 5.05007 13.102L13.9368 4.00147C14.4082 3.51875 15.0604 3.24696 15.75 3.24588C16.4396 3.2448 17.1101 3.51453 17.614 3.99572C18.1179 4.47692 18.4138 5.13016 18.4368 5.81175C18.4598 6.49335 18.2079 7.14745 17.7365 7.63017L10.2717 15.2746C9.88065 15.675 9.21875 15.676 8.80078 15.2769C8.38281 14.8777 8.36076 14.2235 8.75178 13.8231L15.5057 6.90673L14.3658 5.81812L7.61186 12.7345C7.14048 13.2172 6.88857 13.8713 6.91155 14.5529C6.93452 15.2345 7.23051 15.8877 7.73438 16.3689C8.23825 16.8501 8.90875 17.1199 9.59836 17.1188C10.288 17.1177 10.9402 16.8459 11.4116 16.3632L18.8764 8.71878C20.4476 7.10981 20.3599 4.50755 18.6804 2.90366C17.0009 1.29978 14.368 1.3039 12.7969 2.91287L3.91015 12.0134C1.7489 14.2266 1.86946 17.8029 4.1797 20.0091C6.48993 22.2154 10.1083 22.2097 12.2695 19.9965L20.4453 11.624L19.3054 10.5354Z",
    fill: "#4E26A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessengerAttachment);
export default __webpack_public_path__ + "static/media/messenger_attachment.bb676ca350c06a9c5a9c7b09c0de6eec.svg";
export { ForwardRef as ReactComponent };